// src\components\Sidebar.jsx
'use client';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { useAuth, authFetch } from '@/components/AuthProvider';
import { useState, useEffect } from 'react';

const NAV = [
  { href: '/', label: 'Dashboard', icon: 'M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2V9zM9 22V12h6v10' },
  { section: 'Catálogo' },
  {
    href: '/productos', label: 'Productos',
    icon: 'M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4',
    action: { href: '/importar', icon: 'M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4M17 8l-5-5-5 5M12 3v12', title: 'Importar precios' },
  },
  { section: 'Promociones' },
  { href: '/ofertas-del-dia', label: 'Ofertas del Día', icon: 'M12 1v2M12 21v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42' },
  { href: '/ofertas-relampago', label: 'Ofertas Relámpago', icon: 'M13 2L3 14h9l-1 8 10-12h-9l1-8z' },
  { href: '/campanias', label: 'Co-fondeadas', icon: 'M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm8.94 3A8.994 8.994 0 0013 3.06V1h-2v2.06A8.994 8.994 0 003.06 11H1v2h2.06A8.994 8.994 0 0011 20.94V23h2v-2.06A8.994 8.994 0 0020.94 13H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z' },
  { href: '/pre-acordado', label: 'Pre-acordado', icon: 'M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z' },
  { href: '/cupones', label: 'Cupones', icon: 'M2 9a3 3 0 013-3h14a3 3 0 013 3v2a3 3 0 00-3 3 3 3 0 003 3v2a3 3 0 01-3 3H5a3 3 0 01-3-3v-2a3 3 0 003-3 3 3 0 00-3-3V9z' },
  { href: '/seller-campaigns', label: 'Campañas Vendedor', icon: 'M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5' },
  { href: '/promos-producto', label: 'Promos por producto', icon: 'M20.59 13.41l-7.17 7.17a2 2 0 01-2.83 0L2 12V2h10l8.59 8.59a2 2 0 010 2.82zM7 7h.01' },
  { href: '/margenes-promos', label: 'Márgenes de promos', icon: 'M19 5L5 19M6.5 9a2.5 2.5 0 100-5 2.5 2.5 0 000 5zM17.5 20a2.5 2.5 0 100-5 2.5 2.5 0 000 5z' },
  { href: '/carga-masiva', label: 'Carga masiva de precios', icon: 'M3 3h18v18H3zM3 9h18M3 15h18M9 3v18' },
  { section: 'Análisis' },
  { href: '/hotsale', label: 'Cybermonday', icon: 'M12 23c-3.2 0-6-2.5-6-6.5 0-2.8 1.5-5.2 3-7l1.5-2 1 2c.5 1 1 1.5 1.5 1.5s.5-.5.5-1.5c0-2-1.5-4-3-5.5L12 2l1.5 1.5c3 3 5.5 6 5.5 10 0 5-2.8 9.5-7 9.5z', special: 'hotsale' },
  { href: '/alertas', label: 'Alertas', icon: 'M18 8A6 6 0 006 8c0 7-3 9-3 9h18s-3-2-3-9M13.73 21a2 2 0 01-3.46 0' },
  { href: '/bitacora', label: 'Bitácora', icon: 'M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4' },
  { href: '/brand-monitor', label: 'Brand Monitor', icon: 'M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z', adminOnly: false },
  { href: '/tiendas-oficiales', label: 'Rendimiento Tiendas', icon: 'M3 3v18h18M7 16l4-4 4 4 5-6' },
  { href: '/rendimiento', label: 'Rendimiento', icon: 'M3 3v18h18M7 16l4-4 4 4 5-6' },
  { href: '/admin/rentabilidad', label: 'Rentabilidad', icon: 'M12 2v20M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6', adminOnly: false },
  { href: '/marketing/reviews', label: 'Reviews', icon: 'M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z' },
  { section: 'Operaciones' },
  { href: '/ordenes', label: 'Órdenes', icon: 'M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4H6zM3 6h18M16 10a4 4 0 01-8 0' },
  { href: '/logistica', label: 'Logística', icon: 'M20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-3-4zM6 18.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm13.5-9 1.96 2.5H17V9.5h2.5zm-1.5 9c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z' },
  { href: '/stock', label: 'Stock Full', icon: 'M20 7l-8-4-8 4m16 0v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4m8-14l-8 4' },
  { href: '/flex', label: 'Configuración Flex', icon: 'M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0zM12 7a3 3 0 1 0 0 6 3 3 0 0 0 0-6z' },
  { section: 'Facturación', adminOnly: false },
  { href: '/admin/billing', label: 'Facturación', icon: 'M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z', adminOnly: false },
  { section: 'Admin', adminOnly: true },
  { href: '/admin/settings', label: 'Configuración', icon: 'M12.22 2h-.44a2 2 0 00-2 2v.18a2 2 0 01-1 1.73l-.43.25a2 2 0 01-2 0l-.15-.08a2 2 0 00-2.73.73l-.22.38a2 2 0 00.73 2.73l.15.1a2 2 0 011 1.72v.51a2 2 0 01-1 1.74l-.15.09a2 2 0 00-.73 2.73l.22.38a2 2 0 002.73.73l.15-.08a2 2 0 012 0l.43.25a2 2 0 011 1.73V20a2 2 0 002 2h.44a2 2 0 002-2v-.18a2 2 0 011-1.73l.43-.25a2 2 0 012 0l.15.08a2 2 0 002.73-.73l.22-.39a2 2 0 00-.73-2.73l-.15-.08a2 2 0 01-1-1.74v-.5a2 2 0 011-1.74l.15-.09a2 2 0 00.73-2.73l-.22-.38a2 2 0 00-2.73-.73l-.15.08a2 2 0 01-2 0l-.43-.25a2 2 0 01-1-1.73V4a2 2 0 00-2-2zM12 15a3 3 0 110-6 3 3 0 010 6z', adminOnly: true },
  { href: '/admin/actividad', label: 'Actividad', icon: 'M9 19V6l12-3v13M9 19c0 1.1-1.3 2-3 2s-3-.9-3-2 1.3-2 3-2 3 .9 3 2zm12-3c0 1.1-1.3 2-3 2s-3-.9-3-2 1.3-2 3-2 3 .9 3 2z', adminOnly: true },
  { href: '/admin/promotions-audit', label: 'Auditoría de Promos', icon: 'M9 11l3 3L22 4 M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11', adminOnly: true },
  { href: '/admin/permissions', label: 'Permisos', icon: 'M12 11c.97 0 1.81-.5 2.3-1.27.04-.06.06-.13.06-.21l-.01-.01c0-.41-.34-.74-.75-.74H10.4c-.41 0-.75.33-.75.74l.01.01c0 .08.02.15.06.21.49.77 1.33 1.27 2.28 1.27zm9-4V3H3v4h2v13h14V7h2zM5 5h14v2H5V5zm12 13H7V7h10v11z', adminOnly: true },
];

function SvgIcon({ d, size = 15 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d={d} />
    </svg>
  );
}

const EVENTO_TEMAS = {
  hotsale: {
    stops: ['#ff3b30', '#ff6b35', '#ff9500'],
    color: '#ff6b35',
    rgb: '255,107,53',
    icono: 'M12 23c-3.2 0-6-2.5-6-6.5 0-2.8 1.5-5.2 3-7l1.5-2 1 2c.5 1 1 1.5 1.5 1.5s.5-.5.5-1.5c0-2-1.5-4-3-5.5L12 2l1.5 1.5c3 3 5.5 6 5.5 10 0 5-2.8 9.5-7 9.5z',
  },
  cyber: {
    stops: ['#1d4ed8', '#7c3aed', '#06b6d4'],
    color: '#7c3aed',
    rgb: '124,58,237',
    icono: 'M13 2L4.5 13.5H11L10 22l8.5-11.5H12L13 2z',
  },
};

function EventoIcon({ tipo, size = 14, animated = false, blanco = false }) {
  const t = EVENTO_TEMAS[tipo] || EVENTO_TEMAS.hotsale;
  const gid = `eventoGrad-${tipo || 'hotsale'}`;
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill={blanco ? '#fff' : `url(#${gid})`} stroke="none"
      style={animated ? { animation: 'pulse-fire 1.5s ease-in-out infinite' } : {}}>
      <defs>
        <linearGradient id={gid} x1="0" y1="1" x2="1" y2="0">
          <stop offset="0%" stopColor={t.stops[0]} />
          <stop offset="50%" stopColor={t.stops[1]} />
          <stop offset="100%" stopColor={t.stops[2]} />
        </linearGradient>
      </defs>
      <path d={t.icono} />
    </svg>
  );
}

const nombreCorto = (name) => (name || '').replace(/\s*20\d{2}$/, '');

export default function Sidebar() {
  const pathname = usePathname();
  const { user, logout, isAdmin } = useAuth();
  const [open, setOpen] = useState(false);
  const [hotsaleEnabled, setHotsaleEnabled] = useState(false);
  const [evento, setEvento] = useState(null);

  useEffect(() => { setOpen(false); }, [pathname]);
  useEffect(() => {
    if (open) document.body.style.overflow = 'hidden';
    else document.body.style.overflow = '';
    return () => { document.body.style.overflow = ''; };
  }, [open]);

  // Fetch hotsale sidebar config
  useEffect(() => {
    authFetch('/api/admin/config/hotsale_sidebar_enabled')
      .then(r => r.ok ? r.json() : null)
      .then(d => {
        if (d?.value === 'true') setHotsaleEnabled(true);
      })
      .catch(() => {});
  }, []);

  useEffect(() => {
    if (!hotsaleEnabled) return;
    authFetch('/api/hotsale/summary')
      .then(r => r.ok ? r.json() : null)
      .then(d => { if (d?.event) setEvento(d.event); })
      .catch(() => {});
  }, [hotsaleEnabled]);

  const isActivePath = (href) => href === '/' ? pathname === '/' : pathname.startsWith(href);
  const visibleNav = NAV.filter((item) => {
    if (item.adminOnly && !isAdmin) return false;
    if (item.special === 'hotsale' && !hotsaleEnabled) return false;
    // Si la entrada requiere permiso específico y los permisos ya cargaron,
    // ocultar si el usuario no lo tiene.
    if (item.requiredPermission && permissionsLoaded) {
      const { module, permission } = item.requiredPermission;
      if (!hasPermission(module, permission)) return false;
    }
    return true;
  });

  const sidebarContent = (
    <aside className="w-[250px] h-screen flex flex-col z-50"
      style={{ background: 'var(--bg-1)', borderRight: '1px solid var(--border)' }}>

      {/* Logo */}
      <div className="px-4 py-3 flex items-center justify-between flex-shrink-0"
        style={{ borderBottom: '1px solid var(--border)' }}>
        <div className="flex items-center gap-2">
          <svg width="26" height="26" viewBox="0 0 30 30" fill="none">
            <rect width="30" height="30" rx="8" fill="var(--accent)" />
            <path d="M8 10h14v10a2 2 0 01-2 2H10a2 2 0 01-2-2V10z" stroke="#fff" strokeWidth="1.8" />
            <path d="M12 7l3 3-3 3" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M18 7l-2 3" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" />
          </svg>
          <div className="leading-tight">
            <span className="text-[13px] font-bold tracking-tight" style={{ color: 'var(--accent)' }}>TeVeCompras</span>
            <span className="block text-[9.5px] font-medium tracking-wide" style={{ color: 'var(--text-2)' }}>MeliPricing</span>
          </div>
        </div>
        <button onClick={() => setOpen(false)}
          className="lg:hidden p-1 rounded cursor-pointer"
          style={{ color: 'var(--text-2)' }}>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
            <path d="M18 6L6 18M6 6l12 12" />
          </svg>
        </button>
      </div>

      {/* Nav */}
      <nav className="flex-1 px-2 py-1 overflow-y-auto"
        style={{ scrollbarWidth: 'thin', scrollbarColor: 'var(--border) transparent' }}>
        {visibleNav.map((item, idx) => {
          if (item.section) {
            return (
              <div key={`s-${idx}`} className="px-2 pt-2.5 pb-0.5">
                <span className="text-[9px] font-semibold uppercase tracking-wider" style={{ color: 'var(--text-2)' }}>
                  {item.section}
                </span>
              </div>
            );
          }

          const active = isActivePath(item.href);
          const isHotSale = item.special === 'hotsale';

          // Hot Sale special rendering
          if (isHotSale) {
            const tipo = evento?.tipo || 'hotsale';
            const t = EVENTO_TEMAS[tipo] || EVENTO_TEMAS.hotsale;
            const enVivo = !!evento?.is_active;
            const label = evento?.parte_actual?.nombre || (evento?.name ? nombreCorto(evento.name) : item.label);
            const diaChip = evento?.parte_actual ? `${evento.parte_actual.day_index}/${evento.parte_actual.total_days}` : evento?.day_index != null ? `${evento.day_index}/${evento.total_days}` : null;
            const fondo = active
              ? `linear-gradient(135deg, ${t.stops.join(', ')})`
              : `linear-gradient(135deg, rgba(${t.rgb},0.07), rgba(${t.rgb},0.12))`;
            const fondoHover = `linear-gradient(135deg, rgba(${t.rgb},0.13), rgba(${t.rgb},0.2))`;
            return (
              <div key={item.href} className="flex items-center gap-0.5 mb-[1px]">
                <Link
                  href={item.href}
                  className="flex-1 flex items-center gap-[9px] px-2.5 py-[5px] rounded-lg text-[12px] font-semibold transition-all"
                  style={{
                    color: active ? '#fff' : t.color,
                    background: fondo,
                    border: active ? '1px solid transparent' : `1px solid rgba(${t.rgb},0.2)`,
                  }}
                  onMouseEnter={(e) => {
                    if (!active) {
                      e.currentTarget.style.background = fondoHover;
                      e.currentTarget.style.borderColor = `rgba(${t.rgb},0.35)`;
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (!active) {
                      e.currentTarget.style.background = fondo;
                      e.currentTarget.style.borderColor = `rgba(${t.rgb},0.2)`;
                    }
                  }}
                >
                  <EventoIcon tipo={tipo} size={14} animated={!active && enVivo} blanco={active} />
                  <span className="flex-1 truncate">{label}</span>
                  {enVivo && diaChip && (
                    <span className="text-[9px] font-mono px-1.5 py-[1px] rounded-md flex-shrink-0"
                      style={{ background: active ? 'rgba(255,255,255,0.2)' : `rgba(${t.rgb},0.12)`, color: active ? '#fff' : t.color }}>
                      {diaChip}
                    </span>
                  )}
                  {enVivo && (
                    <span className="w-1.5 h-1.5 rounded-full flex-shrink-0"
                      style={{ background: active ? '#fff' : '#ff3b30', animation: 'pulse-dot 1.6s ease-in-out infinite' }} />
                  )}
                </Link>
              </div>
            );
          }

          // Normal items
          return (
            <div key={item.href} className="flex items-center gap-0.5 mb-[1px]">
              <Link
                href={item.href}
                className="flex-1 flex items-center gap-[9px] px-2.5 py-[5px] rounded-lg text-[12px] font-medium transition-colors"
                style={{
                  color: active ? 'var(--accent)' : 'var(--text-1)',
                  background: active ? 'var(--accent-bg)' : 'transparent',
                }}
                onMouseEnter={(e) => { if (!active) { e.currentTarget.style.background = 'var(--bg-hover)'; e.currentTarget.style.color = 'var(--text-0)'; } }}
                onMouseLeave={(e) => { if (!active) { e.currentTarget.style.background = 'transparent'; e.currentTarget.style.color = 'var(--text-1)'; } }}
              >
                <SvgIcon d={item.icon} size={14} />
                <span className="flex-1 truncate">{item.label}</span>
                {item.adminOnly && (
                  <span className="text-[8px] font-semibold uppercase px-1 py-0.5 rounded flex-shrink-0"
                    style={{ background: 'var(--bg-elevated)', color: 'var(--text-2)', border: '1px solid var(--border)' }}>
                    Admin
                  </span>
                )}
              </Link>
              {item.action && (
                <Link href={item.action.href} title={item.action.title}
                  className="p-1.5 rounded cursor-pointer flex-shrink-0 transition-colors"
                  style={{ color: isActivePath(item.action.href) ? 'var(--accent)' : 'var(--text-2)' }}
                  onMouseEnter={(e) => (e.currentTarget.style.color = 'var(--accent)')}
                  onMouseLeave={(e) => (e.currentTarget.style.color = isActivePath(item.action.href) ? 'var(--accent)' : 'var(--text-2)')}>
                  <SvgIcon d={item.action.icon} size={13} />
                </Link>
              )}
            </div>
          );
        })}
      </nav>

      {/* User */}
      <div className="px-3 py-2 flex-shrink-0" style={{ borderTop: '1px solid var(--border)' }}>
        {user && (
          <div className="flex items-center justify-between">
            <div className="flex-1 min-w-0 mr-2">
              <div className="text-[11px] font-medium truncate" style={{ color: 'var(--text-1)' }}>
                {user.displayName || user.name || user.username}
              </div>
              {user.roles && (
                <div className="text-[9px] font-mono truncate" style={{ color: 'var(--text-2)' }}>
                  {user.roles.join(', ')}
                </div>
              )}
            </div>
            <button onClick={logout}
              className="flex items-center gap-1 text-[10px] font-medium px-2 py-1 rounded cursor-pointer"
              style={{ color: 'var(--text-2)' }}
              onMouseEnter={(e) => { e.currentTarget.style.background = 'var(--bg-hover)'; e.currentTarget.style.color = 'var(--red)'; }}
              onMouseLeave={(e) => { e.currentTarget.style.background = ''; e.currentTarget.style.color = 'var(--text-2)'; }}>
              <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                <path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4M16 17l5-5-5-5M21 12H9" />
              </svg>
              Salir
            </button>
          </div>
        )}
      </div>

      <style jsx global>{`
        @keyframes pulse-fire {
          0%, 100% { transform: scale(1); }
          50% { transform: scale(1.2); }
        }
        @keyframes pulse-dot {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.35; }
        }
      `}</style>
    </aside>
  );

  return (
    <>
      <div className="hidden lg:block fixed top-0 left-0 h-screen z-50">{sidebarContent}</div>
      <button onClick={() => setOpen(true)}
        className="lg:hidden fixed top-3 left-3 z-[60] p-2 rounded-lg cursor-pointer shadow-md"
        style={{ background: 'var(--bg-1)', border: '1px solid var(--border)', color: 'var(--text-0)' }}>
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
          <path d="M3 12h18M3 6h18M3 18h18" />
        </svg>
      </button>
      {open && (
        <>
          <div className="lg:hidden fixed inset-0 z-[55] bg-black/50" onClick={() => setOpen(false)} />
          <div className="lg:hidden fixed top-0 left-0 h-screen z-[60]">{sidebarContent}</div>
        </>
      )}
    </>
  );
}